// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './ProviderResultsLists.scss'
import { ProviderTile } from '../../../visit-information/components/provider-tile/ProviderTile'
import { getSearchResultHeaderMainTitle, getSearchResultHeaderSubtitle } from '../../../../helper'

/**
 * ProviderList Component: Displays a list of providers with their information.
 *
 * @param {Object[]} providers List of provider data objects
 *
 */
export const ProviderList = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providers,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  reschedulePrimaryClick,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setProviderInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  date,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  filterPastVisits,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchQuery,
}) => {
  const headerTitle = getSearchResultHeaderMainTitle(providers)

  const headerSubTitle = getSearchResultHeaderSubtitle(providers, filterPastVisits, searchQuery)

  return (
    <div className='provider-list-container'>
      <div className='provider-list-header'>{headerTitle}</div>
      <div className='provider-list-subtitle'>{headerSubTitle}</div>

      {providers.length > 0 &&
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        providers.map((providerWrapper) => {
          const provider = providerWrapper.Provider
          const { Id, ImageUrl, Prefix, FirstName, LastName, Suffix } = provider
          const timeSlotCollection = providerWrapper.TimeSlotCollection || []
          const timeSlots = timeSlotCollection.length > 0 ? timeSlotCollection[0].Times || [] : []

          return (
            // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
            <ProviderTile
              reschedulePrimaryClick={reschedulePrimaryClick}
              setProviderInfo={setProviderInfo}
              key={Id}
              providerId={Id}
              imageUrl={ImageUrl}
              providerName={`${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`.trim()}
              timeSlots={timeSlots}
              date={date}
              timeZone={timeZone}
            />
          )
        })}
    </div>
  )
}
